import CreatePassword from '@/components/auth/create-password/CreatePassword.vue';
import ForgotPassword from '@/components/auth/forgot-password/ForgotPassword.vue';
import OtpVerification from '@/components/auth/otp-verification/OtpVerification.vue';
import SignIn from '@/components/auth/sign-in/SignIn.vue';
import SignUp from '@/components/auth/sign-up/SignUp.vue';
import BoostRewardDetails from '@/components/shopper/boost-rewards/[OrderId].vue';
import BoostRewards from '@/components/shopper/boost-rewards/BoostRewards.vue';
import ContactUs from '@/components/shopper/contact-us/ContactUs.vue';
import DashboardHome from '@/components/shopper/home/HomePage.vue';
import LaybyDetails from '@/components/shopper/lay-by/[OrderId].vue';
import LayBy from '@/components/shopper/lay-by/LayBy.vue';
import PaymentPlan from '@/components/shopper/payment-plan/PaymentPlan.vue';
import ProfilePage from '@/components/shopper/profile/ProfilePage.vue';
import StoresPage from '@/components/shopper/stores/StoresPage.vue';
import SubscriptionsPage from '@/components/shopper/subscriptions/SubscriptionsPage.vue';
import ShopperDashboardLayout from '@/layouts/ShopperDashboardLayout.vue';
import DebiCheckMandateConfirmation from '@/views/DebiCheckMandateConfirmation.vue';
import GenerateOrder from '@/views/GenerateOrder.vue';
import PaymentLink from '@/views/PaymentLink.vue';
import PaymentStatus from '@/views/PaymentStatus.vue';
import ShopperAuth from '@/views/ShopperAuth.vue';
import type { RouteRecordRaw } from 'vue-router';
import { authGuard, canGenerateOrderGuard } from '../utils/auth.utils';
import { widgetRoutes } from './widget';

export const shopperRoutes: RouteRecordRaw = {
  path: '/shopper',
  redirect: '/shopper/auth/sign-in',
  children: [
    {
      path: 'auth',
      name: 'ShopperAuth',
      component: ShopperAuth,
      redirect: 'shopper/auth/sign-in',
      children: [
        { path: 'sign-in', name: 'shopperSignIn', component: SignIn, beforeEnter: authGuard },
        { path: 'sign-up', name: 'shopperSignUp', component: SignUp },
        { path: 'forgot-password', name: 'shopperForgotPassword', component: ForgotPassword },
        {
          path: 'otp-verification',
          name: 'shopperOtpVerification',
          component: OtpVerification,
        },
        {
          path: 'create-password',
          name: 'shopperCreatePassword',
          component: CreatePassword,
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: 'payment',
      name: 'payment',
      component: PaymentStatus,
    },
    { path: 'payment/:id/status', name: 'paymentStatus', component: PaymentStatus },
    {
      path: 'mandate/:id/confirmation',
      name: 'DebiCheckMandateConfirmation',
      component: DebiCheckMandateConfirmation,
    },
    { path: 'payment-link/:id', name: 'PaymentLink', component: PaymentLink, meta: { requiresAuth: true } },
    {
      path: '_generate-order',
      name: '_generateOrder',
      component: GenerateOrder,
      beforeEnter: canGenerateOrderGuard,
    },
    {
      ...widgetRoutes,
      children: [
        ...(widgetRoutes.children || []),
        {
          path: '',
          name: 'shopperDashboard',
          component: ShopperDashboardLayout,
          meta: { requiresAuth: true },
          children: [
            {
              path: '',
              name: 'shopperDashboardHome',
              component: DashboardHome,
            },
            {
              path: 'profile',
              name: 'shopperProfile',
              component: ProfilePage,
            },
            {
              path: 'contact-us',
              name: 'shopperContactUs',
              component: ContactUs,
            },
            {
              path: 'boost-rewards',
              name: 'shopperBoostsRewards',
              component: BoostRewards,
            },
            {
              path: 'boost-rewards/:id',
              name: 'shopperBoostRewardDetails',
              component: BoostRewardDetails,
            },
            {
              path: 'lay-by',
              name: 'shopperLayBy',
              component: LayBy,
            },
            {
              path: 'lay-by/:id',
              name: 'shopperLaybyDetails',
              component: LaybyDetails,
            },
            {
              path: 'payment-plan',
              name: 'shopperPaymentPlan',
              component: PaymentPlan,
            },
            {
              path: 'payment-plan/:id',
              name: 'shopperPaymentPlanDetails',
              component: LaybyDetails,
            },
            {
              path: 'shops',
              name: 'shopperStores',
              component: StoresPage,
            },
            {
              path: 'subscriptions',
              name: 'shopperSubscriptions',
              component: SubscriptionsPage,
            },
          ],
        },
      ],
    },
  ],
};
